import { MainLayout } from "../layouts";
import {
  AddBancosCaixasView,
  AddClassificacaoFinanceiraView,
  AddColecoesView,
  AddCondicaoPagamentoView,
  AddCondicionaisView,
  AddContasPagarView,
  AddContasReceber,
  AddDocumentoFreteView,
  AddEmpresaView,
  AddEtiquestasView,
  AddGrupoPessoasView,
  AddMarcasView,
  AddMdfeView,
  AddMeioPagamentoView,
  AddMensagemPersonalizadaView,
  AddModeloGradeView,
  AddModeloTributacaoView,
  AddNfEntradaView,
  AddNfseView,
  AddNfSaidaView,
  AddOperacoesFiscaisView,
  AddOrcamentoServicoView,
  AddOrcamentosView,
  AddOrdemServicoView,
  AddPedidosView,
  AddPerfilUsuarioView,
  AddPessoaView,
  AddProdutoView,
  AddRegraDescontoView,
  AddSaldoInicialView,
  AddServicoView,
  AddTabelaVendaView,
  AddTagsView,
  AddUsuariosView,
  AddVeiculosView,
  AgendamentoView,
  CaixaView,
  CentralUsuario,
  ConfiguracoesView,
  ContadorContasReceberView,
  ContadorNfEntradaView,
  ImportarPessoasView,
  ImportarProdutoView,
  ImportarXmlView,
  ImportarServicoView,
  ImportarContasReceberView,
  ImportarContasPagarView,
  ListBancosCaixasView,
  ListCentroCustoView,
  ListClassificacaoFinanceiraView,
  ListColecoesView,
  ListCondicionaisView,
  ListCondicoesPagamentoView,
  ListContasPagarView,
  ListContasReceber,
  ListDocumentoFreteView,
  ListEtiquetasView,
  ListFamiliaProdutosView,
  ListGrupoProdutosView,
  ListGrupoServicoView,
  ListGruposPessoasView,
  ListGruposTributarioView,
  ListMarcasView,
  ListMdfeView,
  ListMeioPagamentoView,
  ListMensagemPersonalizadaView,
  ListModeloGradeView,
  ListModeloTributacaoView,
  ListNfEntradaView,
  ListNfseView,
  ListNfSaidaView,
  ListOperacoesFiscaisView,
  ListOrcamentoServicoView,
  ListOrcamentosView,
  ListOrdemServicoView,
  ListPedidosView,
  ListPerfilsUsuariosView,
  ListPessoasView,
  ListPlanosFinanceirosView,
  ListProdutosView,
  ListRegraDescontoView,
  ListRotasView,
  ListSaldoInicialView,
  ListSegmentosView,
  ListServicosView,
  ListSubfamiliaProdutosView,
  ListSubgrupoProdutosView,
  ListTabelaVendaView,
  ListTagsView,
  ListUsuariosView,
  ListVeiculosView,
  MainView,
  ManifescaoDestinatarioView,
  MeuUsuarioView,
  MonitorFiscalView,
  MonitorFaturamentoView,
  PainelAnaliseFiscalView,
  ReajustePrecoView,
  RelatoriosDashboard,
  RelatoriosEstoque,
  RelatoriosFaturamento,
  RelatoriosFinanceiro,
  FluxoDeCaixaView,
  DespesasPorPlanoFinanceiroView,
  DashboardDreView,
  RelatoriosIntegracao,
  RelatoriosServicos,
  MonitorOrdemServicoView,
  MonitorFinanceiroView,
  PainelServicosRecorrentesView,
  ListEnderecosEstoqueView,
  ListEventosFicaisView,
  AddEventoFicalView,
  ListBoletosView,
  AddEmailPersonalizadoView,
  ListEmailPersonalizadoView,
  AuditoriaView,
} from "../views";

const CurrentRoutes = [
  {
    component: MainView,
    exact: true,
    layout: MainLayout,
    path: "/dashboard",
    title: "Dashboard",
    podeExibirNaBusca: true,
    descricao: "Dashboards e informações importantes sobre sua empresa",
  },
  {
    component: ConfiguracoesView,
    exact: true,
    layout: MainLayout,
    path: "/painel-controle/configuracoes",
    title: "Configurações",
    podeExibirNaBusca: true,
    descricao: "Editar configurações importantes sobre o sistema",
  },
  {
    component: ListPessoasView,
    exact: true,
    layout: MainLayout,
    path: "/integracao/pessoas",
    title: "Listagem de pessoas",
    podeExibirNaBusca: true,
    descricao:
      "Veja o cadastro de clientes, colaboradores, fornecedores, etc...",
  },
  {
    component: ImportarPessoasView,
    exact: true,
    layout: MainLayout,
    path: "/integracao/importacao-pessoas",
    title: "Importação Excel",
    podeExibirNaBusca: false,
    descricao: "Importação Excel",
  },
  {
    component: AddPessoaView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/pessoas/create",
    title: "Cadastro de Pessoas",
    podeExibirNaBusca: true,
    descricao: "Crie um novo cliente, colaborador, fornecedor, etc...",
  },
  {
    component: AddPessoaView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/pessoas/:id",
    title: "Edição de Pessoas",
    podeExibirNaBusca: false,
    descricao:
      "Faça a edição de um cliente, colaborador, fornecedor, etc... já existente",
  },
  {
    component: ListUsuariosView,
    exact: true,
    layout: MainLayout,
    path: "/painel-controle/usuarios",
    title: "Listagem de Usuários",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de grupos usuários cadastrados",
  },
  {
    component: AddUsuariosView,
    exact: false,
    layout: MainLayout,
    path: "/painel-controle/usuarios/create",
    title: "Criação de Usuários",
    podeExibirNaBusca: true,
    descricao: "Crie um novo usuário...",
  },
  {
    component: AddUsuariosView,
    exact: false,
    layout: MainLayout,
    path: "/painel-controle/usuarios/:id",
    title: "Edição de Usuários",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de um usuário... já existente",
  },
  {
    component: MeuUsuarioView,
    exact: false,
    layout: MainLayout,
    path: "/meu-usuario",
    title: "Meu Usuário",
    podeExibirNaBusca: true,
    temPermissao: false,
    descricao: "Gerencie seu perfil de usuário",
  },
  {
    component: ListGruposPessoasView,
    exact: true,
    layout: MainLayout,
    path: "/integracao/grupo-pessoas",
    title: "Listagem de grupo de pessoas",
    podeExibirNaBusca: true,
    descricao:
      "Veja a listagem de grupos de pessoas, colaboradores, fornecedores, etc...",
  },
  {
    component: AddGrupoPessoasView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/grupo-pessoas/create",
    title: "Cadastro de grupo de pessoas",
    podeExibirNaBusca: true,
    descricao:
      "Crie um novo grupo de pessoas, colaboradores, fornecedores, etc...",
  },
  {
    component: AddGrupoPessoasView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/grupo-pessoas/:id",
    title: "Edição de grupo de pessoas",
    podeExibirNaBusca: false,
    descricao:
      "Faça a edição de um grupo de pessoas, colaboradores, fornecedores, etc... já existente",
  },
  {
    component: ListSegmentosView,
    exact: true,
    layout: MainLayout,
    path: "/integracao/segmentos",
    title: "Listagem de segmentos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de segmentos de pessoas",
  },
  {
    component: AddEmpresaView,
    exact: false,
    layout: MainLayout,
    path: "/painel-controle/empresas",
    title: "Editar minha Empresa",
    podeExibirNaBusca: true,
    descricao: "Altere alguma informação de sua empresa",
  },
  {
    component: CentralUsuario,
    exact: false,
    layout: MainLayout,
    path: "/painel-controle/central-usuario",
    title: "Central do usuário",
    podeExibirNaBusca: true,
    descricao: "Altere dados do usuário e configurações da plataforma",
  },
  {
    component: ListGrupoProdutosView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/grupo-produtos",
    title: "Grupos de produtos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de grupos de produtos",
  },
  {
    component: ListSubgrupoProdutosView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/subgrupo-produtos",
    title: "Grupos de produtos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de subgrupos de produtos",
  },
  {
    component: ListFamiliaProdutosView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/familia-produtos",
    title: "Famílias de produtos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de famílias de produtos",
  },
  {
    component: ListSubfamiliaProdutosView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/subfamilia-produtos",
    title: "Subfamílias de produtos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de subfamílias de produtos",
  },
  {
    component: ListEnderecosEstoqueView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/enderecos-estoque",
    title: "Endereços de estoque",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de endereços de estoque",
  },
  {
    component: ListProdutosView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/produtos",
    title: "Listagem de produtos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de produtos",
  },
  {
    component: AddProdutoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/produtos/create",
    title: "Cadastro de produtos",
    podeExibirNaBusca: true,
    descricao: "Crie um novo produtos",
  },
  {
    component: ListTabelaVendaView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/tabelas-venda",
    title: "Listagem de tabela de venda",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de tabela de venda",
  },
  {
    component: AddTabelaVendaView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/tabelas-venda/create",
    title: "Cadastro de tabela de venda",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova tabela de venda",
  },
  {
    component: AddTabelaVendaView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/tabelas-venda/:id",
    title: "Edição de tabela de venda",
    podeExibirNaBusca: false,
    descricao: "Edite uma tabela de venda",
  },
  {
    component: AddProdutoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/produtos/:id",
    title: "Edição de produtos",
    podeExibirNaBusca: true,
    descricao: "Faça a edição de um produtos",
  },
  {
    component: ListModeloGradeView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/modelos-grade",
    title: "Listagem de modelos de grade",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de modelos de grade",
  },
  {
    component: AddModeloGradeView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/modelos-grade/create",
    title: "Cadastro de modelo de grade",
    podeExibirNaBusca: true,
    descricao: "Crie um novo modelo de grade",
  },
  {
    component: AddModeloGradeView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/modelos-grade/:id",
    title: "Edição de modelo de grade",
    podeExibirNaBusca: false,
    descricao: "Edite um modelo de grade",
  },
  // {
  //   component: ListConsultaLoteView,
  //   exact: true,
  //   layout: MainLayout,
  //   path: "/estoque/consultas-lote",
  //   title: "Lista de processamento de consulta fiscal em lote",
  //   podeExibirNaBusca: true,
  //   descricao: "Veja a listagem de consulta fiscal em lote",
  // },
  {
    component: ListRegraDescontoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/regras-desconto",
    title: "Listagem de regras de desconto",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de regras de desconto",
  },
  {
    component: AddRegraDescontoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/regras-desconto/create",
    title: "Cadastro de regra de desconto",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova regra de desconto",
  },
  {
    component: AddRegraDescontoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/regras-desconto/:id",
    title: "Edição de regra de desconto",
    podeExibirNaBusca: false,
    descricao: "Edite uma regra de desconto",
  },
  {
    component: ListClassificacaoFinanceiraView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/classificacoes-financeiras",
    title: "Listagem das classificacoes financeiras",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem das classificacoes financeiras",
  },
  {
    component: AddClassificacaoFinanceiraView,
    exact: false,
    layout: MainLayout,
    path: "/financeiro/classificacoes-financeiras/create",
    title: "Cadastro de classificacao",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova classificação financeira",
  },
  {
    component: AddClassificacaoFinanceiraView,
    exact: false,
    layout: MainLayout,
    path: "/financeiro/classificacoes-financeiras/:id",
    title: "Edição de grupo de pessoas",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma classificação financeira já existente",
  },
  {
    component: ListMeioPagamentoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/meios-pagamento",
    title: "Listagem de meios de pagamento",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de meios de pagamento",
  },
  {
    component: AddMeioPagamentoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/meios-pagamento/create",
    title: "Cadastro de meio de pagamento",
    podeExibirNaBusca: true,
    descricao: "Crie um novo meio de pagamento",
  },
  {
    component: AddMeioPagamentoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/meios-pagamento/:id",
    title: "Edição de meio de pagamento",
    podeExibirNaBusca: false,
    descricao: "Edite um meio de pagamento",
  },
  {
    component: ListCondicoesPagamentoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/condicoes-pagamento",
    title: "Listagem de condições de pagamento",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de condições de pagamento",
  },
  {
    component: AddCondicaoPagamentoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/condicoes-pagamento/create",
    title: "Cadastro de condição de pagamento",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova condição de pagamento",
  },
  {
    component: AddCondicaoPagamentoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/condicoes-pagamento/:id",
    title: "Edição de condição de pagamento",
    podeExibirNaBusca: false,
    descricao: "Edite uma condição de pagamento",
  },
  {
    component: ListGruposTributarioView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/grupos-tributario",
    title: "Listagem de grupos tributário",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de grupos tributário",
  },
  {
    component: ListOperacoesFiscaisView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/operacoes-fiscais",
    title: "Listagem de operações fiscais",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de operações fiscais",
  },
  {
    component: AddOperacoesFiscaisView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/operacoes-fiscais/create",
    title: "Cadastro de operação fiscal",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova operação fiscal",
  },
  {
    component: AddOperacoesFiscaisView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/operacoes-fiscais/:id",
    title: "Edição de operação fiscal",
    podeExibirNaBusca: false,
    descricao: "Edite uma operação fiscal",
  },
  {
    component: ListModeloTributacaoView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/modelos-tributacao",
    title: "Listagem de operações fiscais",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de modelos de tributacao",
  },
  {
    component: AddModeloTributacaoView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/modelos-tributacao/create",
    title: "Cadastro de Modelo de Tributação",
    podeExibirNaBusca: true,
    descricao: "Crie um novo modelo de tributação",
  },
  {
    component: AddModeloTributacaoView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/modelos-tributacao/:id",
    title: "Edição de Modelo de Tributação",
    podeExibirNaBusca: false,
    descricao: "Edite um modelo de tributação",
  },
  {
    component: MonitorFiscalView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/monitor-fiscal",
    title: "Edição de Modelo de Tributação",
    podeExibirNaBusca: false,
    descricao: "Edite um modelo de tributação",
  },
  {
    component: PainelAnaliseFiscalView,
    exact: true,
    layout: MainLayout,
    path: "/fiscal/painel-analise-fiscal",
    title: "Painel de Análise Fiscal",
    podeExibirNaBusca: true,
    descricao: "Indicativos fiscais gerados por IA a partir da base de produtos e vendas do cliente",
  },
  {
    component: ListNfSaidaView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/nf-saida",
    title: "Listagem de nf de saida",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de nf de saida",
  },
  {
    component: AddNfSaidaView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/nf-saida/create",
    title: "Cadastro de nf de saida",
    podeExibirNaBusca: true,
    descricao: "Crie um novo nf de saida",
  },
  {
    component: AddNfSaidaView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/nf-saida/:id",
    title: "Edição de nf de saida",
    podeExibirNaBusca: false,
    descricao: "Edite um nf de saida",
  },
  {
    component: ListBancosCaixasView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/bancos-caixas",
    title: "Listagem de bancos e caixas",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de bancos e caixas",
  },
  {
    component: AddBancosCaixasView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/bancos-caixas/create",
    title: "Cadastro de conta",
    podeExibirNaBusca: true,
    descricao: "Crie um novo conta",
  },
  {
    component: AddBancosCaixasView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/bancos-caixas/:id",
    title: "Edição de conta",
    podeExibirNaBusca: false,
    descricao: "Edite um conta",
  },
  {
    component: ListPedidosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/pedidos",
    title: "Listagem de pedidos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de pedidos",
  },
  {
    component: AddPedidosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/pedidos/create",
    title: "Cadastro de pedidos",
    podeExibirNaBusca: true,
    descricao: "Crie um novo pedido",
  },
  {
    component: AddPedidosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/pedidos/:id",
    title: "Edição de pedidos",
    podeExibirNaBusca: true,
    descricao: "Edite um pedido",
  },
  {
    component: ListOrcamentosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/orcamentos",
    title: "Listagem de orçamento",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de orçamento",
  },
  {
    component: AddOrcamentosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/orcamentos/create",
    title: "Cadastro de orçamento",
    podeExibirNaBusca: true,
    descricao: "Crie um novo orçamento",
  },
  {
    component: AddOrcamentosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/orcamentos/:id",
    title: "Edição de orçamento",
    podeExibirNaBusca: true,
    descricao: "Edite um orçamento",
  },
  {
    component: ListCondicionaisView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/condicionais",
    title: "Listagem de condicional",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de condicionais",
  },
  {
    component: AddCondicionaisView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/condicionais/create",
    title: "Cadastro de condicional",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova condicional",
  },
  {
    component: AddCondicionaisView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/condicionais/:id",
    title: "Edição de condicional",
    podeExibirNaBusca: true,
    descricao: "Edite uma condicional",
  },
  {
    component: ListContasReceber,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/contas-receber",
    title: "Listagem de contas a receber",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de contas a receber",
  },
  {
    component: AddContasReceber,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/contas-receber/create",
    title: "Cadastro de conta a receber",
    podeExibirNaBusca: true,
    descricao: "Crie um nova conta a receber",
  },
  {
    component: ListBoletosView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/contas-receber/boletos",
    title: "Listagem de boletos cadastrados",
    podeExibirNaBusca: false,
    descricao: "Veja a listagem de boletos",
  },
  {
    component: AddContasReceber,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/contas-receber/:id",
    title: "Edição de conta a receber",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma conta a receber",
  },
  {
    component: ListContasPagarView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/contas-pagar",
    title: "Listagem de contas a pagar",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de contas a pagar",
  },
  {
    component: AddContasPagarView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/contas-pagar/create",
    title: "Cadastro de conta a pagar",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova conta a pagar",
  },
  {
    component: AddContasPagarView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/contas-pagar/:id",
    title: "Edição de conta a pagar",
    podeExibirNaBusca: false,
    descricao: "Edite uma conta a pagar",
  },
  {
    component: ImportarContasReceberView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/importacao-contas-receber",
    title: "Importação de Contas a Receber",
    podeExibirNaBusca: false,
    descricao: "Importação de Contas a Receber",
  },
  {
    component: ImportarContasPagarView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/importacao-contas-pagar",
    title: "Importação de Contas a Pagar",
    podeExibirNaBusca: false,
    descricao: "Importação de Contas a Pagar",
  },
  {
    component: CaixaView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/caixa",
    title: "Caixa",
    podeExibirNaBusca: true,
    descricao: "Cadastro do Caixa",
  },
  {
    component: ListPlanosFinanceirosView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/planos-financeiros",
    title: "Planos Financeiros",
    podeExibirNaBusca: true,
    descricao: "Listagem de Planos Financeiros",
  },
  {
    component: ListCentroCustoView,
    exact: true,
    layout: MainLayout,
    path: "/financeiro/centro-custo",
    title: "Listagem de centros de custo",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de centros de custo",
  },
  {
    component: ListNfEntradaView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/nf-entrada",
    title: "Listagem de NF de entrada",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de NFs de entrada",
  },
  {
    component: AddNfEntradaView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/nf-entrada/create",
    title: "Cadastro de NF de entrada",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova NF de entrada",
  },
  {
    component: AddNfEntradaView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/nf-entrada/:id",
    title: "Edição de NF de entrada",
    podeExibirNaBusca: false,
    descricao: "Edite uma NF de entrada",
  },
  {
    component: ManifescaoDestinatarioView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/manifestacao-destinatario",
    title: "Manifestação Destinatário",
    podeExibirNaBusca: true,
    descricao: "Consulte a Manifestação Destinatário",
  },
  {
    component: ListDocumentoFreteView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/documentos-frete",
    title: "Listagem de documentos de frete",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de documentos de frete",
  },
  {
    component: AddDocumentoFreteView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/documentos-frete/create",
    title: "Cadastro de documento de frete",
    podeExibirNaBusca: true,
    descricao: "Crie um novo documento de frete",
  },
  {
    component: AddDocumentoFreteView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/documentos-frete/:id",
    title: "Edição de documento de frete",
    podeExibirNaBusca: false,
    descricao: "Edite uma documento de frete",
  },
  {
    component: RelatoriosFaturamento,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-faturamento",
    title: "Listagem de relatórios de faturamento",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de relatórios de faturamento",
  },
  {
    component: RelatoriosFinanceiro,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-financeiro",
    title: "Listagem de relatórios de financeiro",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de relatórios de financeiro",
  },
  {
    component: FluxoDeCaixaView,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-financeiro/fluxo-de-caixa",
    title: "Fluxo de Caixa",
    podeExibirNaBusca: true,
    descricao: "Acompanhe entradas, saídas e saldo do período",
  },
  {
    component: DespesasPorPlanoFinanceiroView,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-financeiro/despesas-por-plano-financeiro",
    title: "Despesas por Categoria",
    podeExibirNaBusca: true,
    descricao: "Análise de despesas por plano financeiro e centro de custo",
  },
  {
    component: DashboardDreView,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-financeiro/dre",
    title: "DRE",
    podeExibirNaBusca: true,
    descricao: "Demonstração do Resultado do Exercício",
  },
  {
    component: RelatoriosServicos,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-servicos",
    title: "Listagem de relatórios de serviços",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de relatórios de serviços",
  },
  {
    component: RelatoriosIntegracao,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-integracao",
    title: "Listagem de relatórios de integracao",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de relatórios de integracao",
  },
  {
    component: RelatoriosEstoque,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-estoque",
    title: "Listagem de relatórios de estoque",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de relatórios de estoque",
  },
  // {
  //   component: DreGerencialView,
  //   exact: true,
  //   layout: MainLayout,
  //   path: "/dre-gerencial",
  //   title: "Exibição do relatório DRE Gerencial da empresa",
  //   podeExibirNaBusca: true,
  //   descricao: "Veja o DRE Gerencial da empresa",
  // },
  {
    component: RelatoriosDashboard,
    exact: true,
    layout: MainLayout,
    path: "/relatorios-dashboard",
    title: "Relatórios de Dashboard",
    podeExibirNaBusca: true,
    descricao: "Veja os relatórios de dashboard",
  },
  {
    component: MonitorOrdemServicoView,
    exact: true,
    layout: MainLayout,
    path: "/monitor-ordem-servico",
    title: "Monitor de Ordem de Serviço",
    podeExibirNaBusca: true,
    descricao: "Dashboard de acompanhamento das ordens de serviço",
  },
  {
    component: MonitorFinanceiroView,
    exact: true,
    layout: MainLayout,
    path: "/monitor-financeiro",
    title: "Monitor Financeiro",
    podeExibirNaBusca: true,
    descricao:
      "Dashboard de recebimentos, pagamentos, inadimplência e fluxo de caixa",
  },
  {
    component: MonitorFaturamentoView,
    exact: true,
    layout: MainLayout,
    path: "/monitor-faturamento",
    title: "Monitor Faturamento",
    podeExibirNaBusca: true,
    descricao:
      "Dashboard de faturamento",
  },
  {
    component: ContadorContasReceberView,
    exact: true,
    layout: MainLayout,
    path: "/contador/contas-receber",
    title: "Listagem de relatórios de contas a receber para o contador",
    podeExibirNaBusca: true,
    descricao:
      "Veja a listagem de relatórios de contas a receber para o contador",
  },
  {
    component: ListPerfilsUsuariosView,
    exact: true,
    layout: MainLayout,
    path: "/painel-controle/perfis-usuarios",
    title: "Listagem de perfil de usuarios",
    podeExibirNaBusca: false,
    descricao: "Veja a listagem de perfil de usuarios",
  },
  {
    component: AddPerfilUsuarioView,
    exact: true,
    layout: MainLayout,
    path: "/painel-controle/perfis-usuarios/create",
    title: "Cadastro de perfil de usuario",
    podeExibirNaBusca: false,
    descricao: "Crie um novo perfil de usuario",
  },
  {
    component: AddPerfilUsuarioView,
    exact: true,
    layout: MainLayout,
    path: "/painel-controle/perfis-usuarios/:id",
    title: "Edição de perfil de usuario",
    podeExibirNaBusca: false,
    descricao: "Edite um perfil de usuario",
  },
  {
    component: ContadorNfEntradaView,
    exact: true,
    layout: MainLayout,
    path: "/contador/nf-entrada",
    title: "Contador: NF Entrada",
    podeExibirNaBusca: true,
    descricao: "Relatório NF entrada contador",
  },
  {
    component: ListSaldoInicialView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/saldo-inicial",
    title: "Listagem de ajuste de estoque",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de ajuste de estoque",
  },
  {
    component: AddSaldoInicialView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/saldo-inicial/create",
    title: "Cadastro de ajuste de estoque",
    podeExibirNaBusca: true,
    descricao: "Crie um ajuste de estoque",
  },
  {
    component: AddSaldoInicialView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/saldo-inicial/:id",
    title: "Visualizar ajuste estoque",
    podeExibirNaBusca: false,
    descricao: "Visualize um ajuste de estoque",
  },
  {
    component: ImportarXmlView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/importacao-xml",
    title: "Importação XML",
    podeExibirNaBusca: false,
    descricao: "Importação XML",
  },
  {
    component: ListEtiquetasView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/etiquetas",
    title: "Listagem de etiquetas",
    podeExibirNaBusca: false,
    descricao: "Visualize uma lista de etiquetas",
  },
  {
    component: AddEtiquestasView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/etiquetas/create",
    title: "Cadastro de etiqueta",
    podeExibirNaBusca: false,
    descricao: "Crie uma etiqueta",
  },
  {
    component: AddEtiquestasView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/etiquetas/:id",
    title: "Visualizar etiqueta",
    podeExibirNaBusca: false,
    descricao: "Visualize uma etiqueta",
  },
  {
    component: ImportarProdutoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/importacao-produto",
    title: "Importação XML",
    podeExibirNaBusca: false,
    descricao: "Importação XML",
  },
  {
    component: ImportarServicoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/importacao-servico",
    title: "Importação de Serviços",
    podeExibirNaBusca: false,
    descricao: "Importação de Serviços",
  },
  {
    component: ListTagsView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/tags",
    title: "Listagem de tags",
    podeExibirNaBusca: false,
    descricao: "Visualize uma lista de tags",
  },
  {
    component: AddTagsView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/tags/create",
    title: "Cadastro de tag",
    podeExibirNaBusca: false,
    descricao: "Crie uma tag",
  },
  {
    component: AddTagsView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/tags/:id",
    title: "Visualizar tag",
    podeExibirNaBusca: false,
    descricao: "Visualize uma tag",
  },
  {
    component: ListRotasView,
    exact: true,
    layout: MainLayout,
    path: "/integracao/rotas",
    title: "Listagem de rotas",
    podeExibirNaBusca: false,
    descricao: "Visualize uma lista de rotas",
  },
  {
    component: ListMarcasView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/marcas",
    title: "Listagem de marcas",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de marcas",
  },
  {
    component: AddMarcasView,
    exact: false,
    layout: MainLayout,
    path: "/estoque/marcas/create",
    title: "Cadastro de marcas",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova marca",
  },
  {
    component: AddMarcasView,
    exact: false,
    layout: MainLayout,
    path: "/estoque/marcas/:id",
    title: "Edição de marcas",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma marca já existente",
  },
  {
    component: ListColecoesView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/colecoes",
    title: "Listagem de colecoes",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de coleções",
  },
  {
    component: AddColecoesView,
    exact: false,
    layout: MainLayout,
    path: "/estoque/colecoes/create",
    title: "Cadastro de colecoes",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova coleção",
  },
  {
    component: AddColecoesView,
    exact: false,
    layout: MainLayout,
    path: "/estoque/colecoes/:id",
    title: "Edição de colecoes",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma coleção já existente",
  },
  {
    component: AddMensagemPersonalizadaView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/mensagem-personalizada/create",
    title: "Cadastro de Mensagem Personalizada",
    podeExibirNaBusca: false,
    descricao: "Faça o cadastro de uma mensagem personalizada",
  },
  {
    component: AddMensagemPersonalizadaView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/mensagem-personalizada/:id",
    title: "Edição de Mensagem Personalizada",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma mensagem personalizada",
  },
  {
    component: ListMensagemPersonalizadaView,
    exact: true,
    layout: MainLayout,
    path: "/integracao/mensagem-personalizada",
    title: "Listagem de mensagem personalizada",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de mensagem personalizada",
  },
  {
    component: ReajustePrecoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/reajuste-preco",
    title: "Reajuste Preço",
    podeExibirNaBusca: true,
    descricao: "Faça um Reajuste de Preço",
  },
  {
    component: ListVeiculosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/veiculos",
    title: "Listagem de Veículos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de veículos",
  },
  {
    component: AddVeiculosView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/veiculos/create",
    title: "Cadastro de Veículos",
    podeExibirNaBusca: true,
    descricao: "Crie um novo veículo",
  },
  {
    component: AddVeiculosView,
    exact: false,
    layout: MainLayout,
    path: "/faturamento/veiculos/:id",
    title: "Edição de Veículos",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de um veículo",
  },
  {
    component: ListMdfeView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/mdfe",
    title: "Listagem de MDFE",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de MDFE",
  },
  {
    component: AddMdfeView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/mdfe/create",
    title: "Cadastro de MDFE",
    podeExibirNaBusca: true,
    descricao: "Crie um novo MDFE",
  },
  {
    component: AddMdfeView,
    exact: false,
    layout: MainLayout,
    path: "/faturamento/mdfe/:id",
    title: "Edição de MDFE",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de um MDFE",
  },
  {
    component: ListGrupoServicoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/grupo-servicos",
    title: "Grupos de servicos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de grupos de servicos",
  },
  {
    component: ListServicosView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/servicos",
    title: "Listagem de Serviços",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de serviços",
  },
  {
    component: AddServicoView,
    exact: true,
    layout: MainLayout,
    path: "/estoque/servicos/create",
    title: "Cadastro de Serviços",
    podeExibirNaBusca: true,
    descricao: "Crie um novo serviço",
  },
  {
    component: AddServicoView,
    exact: false,
    layout: MainLayout,
    path: "/estoque/servicos/:id",
    title: "Edição de Serviços",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de um serviço",
  },
  {
    component: ListOrcamentoServicoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/orcamento-servicos",
    title: "Listagem de orçamentos de serviço",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de orçamentos de serviço",
  },
  {
    component: AddOrcamentoServicoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/orcamento-servicos/create",
    title: "Cadastro de orçamentos de serviço",
    podeExibirNaBusca: true,
    descricao: "Crie um novo orçamento de serviço",
  },
  {
    component: AddOrcamentoServicoView,
    exact: false,
    layout: MainLayout,
    path: "/faturamento/orcamento-servicos/:id",
    title: "Edição de orçamentos de serviço",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de um orçamento de serviço",
  },
  {
    component: ListOrdemServicoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/ordem-servicos",
    title: "Listagem de ordens de serviço",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de ordens de serviço",
  },
  {
    component: AddOrdemServicoView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/ordem-servicos/create",
    title: "Cadastro de ordem de serviço",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova ordem de serviço",
  },
  {
    component: AddOrdemServicoView,
    exact: false,
    layout: MainLayout,
    path: "/faturamento/ordem-servicos/:id",
    title: "Edição de ordem de serviço",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma ordem de serviço",
  },
  {
    component: ListNfseView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/nfse",
    title: "Listagem de NFS-e",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de NFS-e",
  },
  {
    component: AddNfseView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/nfse/create",
    title: "Cadastro de NFS-e",
    podeExibirNaBusca: true,
    descricao: "Crie uma nova NFS-e",
  },
  {
    component: AddNfseView,
    exact: false,
    layout: MainLayout,
    path: "/faturamento/nfse/:id",
    title: "Edição de NFS-e",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma NFS-e",
  },
  {
    component: AgendamentoView,
    exact: true,
    layout: MainLayout,
    path: "/servicos/agendamento",
    title: "Listagem de Agendamentos",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de MDFE",
  },
  {
    component: PainelServicosRecorrentesView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/painel-servicos-recorrentes",
    title: "Painel de Serviços Recorrentes",
    podeExibirNaBusca: true,
    descricao: "Painel de controle de recorrência de serviços",
  },
  {
    component: ListEventosFicaisView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/eventos-fiscais",
    title: "Listagem de eventos fiscais",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de eventos fiscais",
  },
  {
    component: AddEventoFicalView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/eventos-fiscais/create",
    title: "Cadastro de evento fiscal",
    podeExibirNaBusca: true,
    descricao: "Crie um novo evento fiscal",
  },
  {
    component: AddEventoFicalView,
    exact: true,
    layout: MainLayout,
    path: "/faturamento/eventos-fiscais/:id",
    title: "Edição de evento fiscal",
    podeExibirNaBusca: true,
    descricao: "Faça a edição de um evento fiscal",
  },
  {
    component: AddEmailPersonalizadoView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/email-personalizado/create",
    title: "Cadastro de Email Personalizado",
    podeExibirNaBusca: false,
    descricao: "Faça o cadastro de uma email personalizado",
  },
  {
    component: AddEmailPersonalizadoView,
    exact: false,
    layout: MainLayout,
    path: "/integracao/email-personalizado/:id",
    title: "Edição de Email Personalizado",
    podeExibirNaBusca: false,
    descricao: "Faça a edição de uma email personalizado",
  },
  {
    component: ListEmailPersonalizadoView,
    exact: true,
    layout: MainLayout,
    path: "/integracao/email-personalizado",
    title: "Listagem de Email Personalizado",
    podeExibirNaBusca: true,
    descricao: "Veja a listagem de email personalizado",
  },
  {
    component: AuditoriaView,
    exact: true,
    layout: MainLayout,
    path: "/auditoria",
    title: "Auditoria",
    podeExibirNaBusca: true,
    descricao: "Veja a auditoria do sistema",
  },
];

export default CurrentRoutes;
